import {DisplayControlCreate, DisplayControlResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class DisplayControlApi extends CrudApiAbstract<
  DisplayControlResource,
  DisplayControlCreate
> {
  public constructor() {
    super(`${ResourceType.DisplayControl}s`);
  }
}
